export default [
  {
    path: '/b/ruangan',
    redirect: '/b/ruangan',
    name: 'bRuangan',
    component: () => import('@/views/NestedRoute.vue'),
    children: [
      {
        path: '',
        name: 'bRuanganIndex',
        component: () => import('@/views/b/ruangan/Index.vue'),
        meta: {
          action: 'Lihat',
          resource: 'b-ruangan',
          pageTitle: 'Ruangan',
          breadcrumb: [
            {
              text: 'Ruangan',
              active: true,
            },
          ],
        },
      },
      {
        path: '/b/ruangan/create',
        name: 'bRuanganCreate',
        component: () => import('@/views/b/ruangan/Create.vue'),
        meta: {
          action: 'Buat',
          resource: 'b-ruangan',
          pageTitle: 'Ruangan',
          breadcrumb: [
            {
              text: 'Ruangan',
            },
            {
              text: 'Tambah',
              active: true,
            },
          ],
        },
      },
      {
        path: '/b/ruangan/input',
        name: 'bRuanganInput',
        component: () => import('@/views/b/ruangan/Input.vue'),
        meta: {
          action: 'Buat',
          resource: 'b-ruangan',
          pageTitle: 'Ruangan',
          breadcrumb: [
            {
              text: 'Ruangan',
            },
            {
              text: 'Input',
              active: true,
            },
          ],
        },
      },
      {
        path: '/b/ruangan/update/:guidAset/:kolok',
        name: 'bRuanganUpdate',
        component: () => import('@/views/b/ruangan/Update.vue'),
        meta: {
          action: 'Ubah',
          resource: 'b-ruangan',
          pageTitle: 'Ruangan',
          breadcrumb: [
            {
              text: 'Ruangan',
            },
            {
              text: 'Update',
              active: true,
            },
          ],
        },
        props: true,
      },
      {
        path: '/b/ruangan/detail/:guidAset/:kolok/:kolok_gedung',
        name: 'bRuanganDetail',
        component: () => import('@/views/b/ruangan/Detail.vue'),
        meta: {
          action: 'Detail',
          resource: 'b-ruangan',
          pageTitle: 'Ruangan',
          breadcrumb: [
            {
              text: 'Ruangan',
            },
            {
              text: 'Detail',
              active: true,
            },
          ],
        },
        props: true,
      },
    ],
  },
]
